











































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CategoryRecommendationsBlockViewModel } from '@/types/contentServerContract';
import { RecommendedCategoriesViewModel, RecommendedCategoryViewObject } from '@/types/apiServerContract';
import loggingService from '@/core/logging.service';
import Api from '@/project/http/Api.service';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import breakpointService from '@/core/responsive/breakpoints/breakpoints.service';
import responsiveProductImageService from '@/project/product/image/responsiveProductImage.service';
import { debounce } from 'lodash';
import GTMService from '@/project/tracking/gtm/GTM.service';

@Component({
    components: { SmartHeadline }
})
export default class CategoryRecommendationsBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    })
    content!: CategoryRecommendationsBlockViewModel;

    @Prop({
        required: false,
        type: Boolean,
        default: false
    })
    isFirstBlock!: boolean;

    rendered: boolean = false;
    activeBreakpoint: string = '';
    result: RecommendedCategoriesViewModel | null = null;
    debouncedTrackCategoryViewed = debounce(this.doTrackCategoryViewed, 500);
    viewedCategories: { name: string, id: string }[] = [];

    get sliderOptions() {
        return {
            spaceBetween: 12,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            slidesPerGroupAuto: true,
            loop: false,
            loopFillGroupWithBlank: false,
            watchSlidesVisibility: true,
            watchOverflow: true,
            setWrapperSize: true,
            navigation: {
                nextEl: '.' + this.nextButtonSelector,
                prevEl: '.' + this.prevButtonSelector
            },
            grabCursor: true,
            instanceName: this.id,
            observer: true,
            observeParents: true,
            observeSlideChildren: true
        };
    }

    get id() {
        return new Date().valueOf();
    }

    get prevButtonSelector() {
        return 'custom-swiper-button-prev-' + this.id;
    }

    get nextButtonSelector() {
        return 'custom-swiper-button-next-' + this.id;
    }

    handleBreakpointChange() {
        const newBreakpoint = breakpointService.getActiveBreakpoint();
        if (newBreakpoint !== this.activeBreakpoint) {
            this.activeBreakpoint = newBreakpoint;
            this.rendered = false;
            this.$nextTick(() => this.rendered = true);
        }
    }

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    async getCategoryData() {
        try {
            this.result = await Api.recommendations.recommendByCategory({
                categoryIdFilterPositiveList: this.content.categoryIdFilterPositiveList,
                categoryIdFilterNegativeList: this.content.categoryIdFilterNegativeList,
                brandIdFilterList: this.content.brandIdFilterList,
                displayedAtLocation: this.content.displayLocation,
                periodDays: this.content.interval,
                popularityType: this.content.popularity,
                categoryCount: this.content.categoryCount
            });
        } catch (e) {
            loggingService.error(e);
        }
    }

    get headline(): string | undefined {
        return this.content?.headline;
    }

    resizeImageByPath(path: string): { x1: string, x2: string } {
        return {
            x1: responsiveProductImageService.formatImageUrl(path, responsiveProductImageService.ImageSizePlaceholderValues.W86),
            x2: responsiveProductImageService.formatImageUrl(path, responsiveProductImageService.ImageSizePlaceholderValues.W172)
        };
    }

    handleClickCategory(category:RecommendedCategoryViewObject) {
        GTMService.trackCreativeClick(`recommendedCategory:${category.displayName}`, `recommendedCategory:${category.categoryId}`);
    }

    handleSlideVisible(category:RecommendedCategoryViewObject) {
        this.viewedCategories.push({ name: `recommendedCategory:${category.displayName}`, id: `recommendedCategory:${category.categoryId}` });
        this.debouncedTrackCategoryViewed();
    }

    doTrackCategoryViewed() {
        const categories = [...this.viewedCategories];
        this.viewedCategories = [];
        GTMService.trackCreativeView(categories);
    }

    created() {
        this.getCategoryData();
    }

    mounted() {
        this.activeBreakpoint = breakpointService.getActiveBreakpoint();
        breakpointService.addListener(this.handleBreakpointChange);
        this.$nextTick(() => {
            this.rendered = true;
        });
    }

    destroyed() {
        breakpointService.removeListener(this.handleBreakpointChange);
    }
}
